'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Alert = function (_BaseIcon) {
  (0, _inherits3.default)(Alert, _BaseIcon);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, (Alert.__proto__ || (0, _getPrototypeOf2.default)(Alert)).apply(this, arguments));
  }

  (0, _createClass3.default)(Alert, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M19.5258082 21.75168H16.308L15.2250411 8.67500308h5.3842192L19.5258082 21.75168zm-1.6086575 5.9657846c-1.2639452 0-2.2694795-1.0033231-2.2694795-2.2656s1.0055343-2.2660923 2.2694795-2.2660923 2.2699726 1.0038154 2.2699726 2.2660923-1.0060274 2.2656-2.2699726 2.2656zm16.7518356-2.4206769L21.5210959 2.64521846c-2.0465754-3.52541538-5.3980274-3.5273846-7.448548-.00443077L.87879452 25.3022031c-2.05052055 3.5224615-.3890959 6.4044307 3.69221918 6.4044307h26.3983562c4.0808219 0 5.7456986-2.8844307 3.6996164-6.4098461z'
        }, this.getPathProps()))
      );
    }
  }]);
  return Alert;
}(_BaseIcon3.default);
/*eslint-enable */


Alert.defaultProps = {
  width: 37,
  height: 33,
  viewBox: '-1 -1 37 33'
};
exports.default = Alert;
//# sourceMappingURL=Alert.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Alert.js
// module id = 270
// module chunks = 0